module.exports = __webpack_public_path__ + "static/media/25.0b9f5d44.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/shirts/25.png
// module id = 985
// module chunks = 0